<template>
  <div class="orderList">
    <div class="carBlock">
      <div class="carInfo">
        <div class="left">
          <img class="carImg" :src="carInfo.ImgUrl || defaultCarImg"/>
          <div class="carinfo">
            <span class="carname">{{carInfo.CarClass}}</span>
            <span>{{carInfo.CarNumber}}</span>
          </div>
        </div>
        <div class="right">
          <span>累计收益</span>
          <span class="amount">￥{{TotalIncome}}</span>
        </div>
      </div>
    </div>
    <div class="orderBlock">
      <div class="con">
        <div class="item" v-for="(item,index) in orderInfo" :key="index">
          <div class="carsInfo">
            <div class="orderNum">订单号：{{ item.OrderNumber }}</div>
            <div class="carStatus">{{ item.StatusText }}</div>
          </div>
          <div class="top">
            <span>{{item.StartTime}}</span>
            <span class="date">{{item.total_time.days}}{{item.total_time.hours}}</span>
            <span>{{item.EndTime}}</span>
          </div>
          <div class="bottom">
            <span>订单收入</span>
            <span class="NoAmount" v-if="item.Status==1 || item.Status==2">订单未结算</span>
            <span class="amount" v-else>￥{{item.Income}}</span>
          </div>
        </div>
        <div class="nodata" v-if="orderInfo.length ==0">
          <img src="@/assets/images/peccancy/nodata.png" />
          <span>您的车辆还没有订单~</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getorders } from "@/utils/api";
import { getMonth, getDate, getDay, getTime } from "@/utils/formatDate";
export default {
  name: "orderList",
  data: function() {
    return {
      CarID:0,
      TotalIncome: 0,
      defaultCarImg: "/static/images/index/car.png",
      carInfo: {
        CarClass: "车辆名称",
        CarNumber:'0000',
        ImgUrl: ""
      },
      orderInfo: []
    };
  },
  components: {},
  created() {
    this.CarID = this.$route.query.CarID || 0;
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      let res = await getorders({
        data: {
          CarId: this.CarID,
          pageSize: 3000
        }
      });
      if (res.Code == 100) {
        this.carInfo = res.Data.CarInfo;
        for (var i = 0; i < res.Data.Rows.length; i++) {
          res.Data.Rows[i].total_time = this.setDay(
            res.Data.Rows[i].EndTime.replace('T',' '),
            res.Data.Rows[i].StartTime.replace('T',' ')
          );
          res.Data.Rows[i].StartTime = res.Data.Rows[i].StartTime.slice(2,16).replace('T',' ');
          res.Data.Rows[i].EndTime = res.Data.Rows[i].EndTime.slice(2,16).replace('T',' ');
        }
        this.TotalIncome = res.Data.TotalIncome;
        this.orderInfo = res.Data.Rows;
        for( let i=0;i<this.orderInfo.length;i++ ){
          let _status = this.orderInfo[i].Status;
          switch (_status){
            //1，预定，2，在租，3已结算，4已取消
            case 1:
              this.orderInfo[i].StatusText = '预定';
              break;
            case 2:
              this.orderInfo[i].StatusText = '在租';
              break;
            case 3:
              this.orderInfo[i].StatusText = '结算';
              break;
            case 4:
              this.orderInfo[i].StatusText = '取消';
              break;
            default:
              this.orderInfo[i].StatusText = ''
          }

        }
      }
    },
    //计算租车总时间
    setDay(stopTime, startTime) {
      let timeSpan = getTime(stopTime) - getTime(startTime);
      let tempDays = timeSpan / (1000 * 60 * 60 * 24);
      let days = tempDays >= 0 ? Math.floor(tempDays) : Math.ceil(tempDays);
      let hours = Math.floor(
        (timeSpan % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      let total_time = {
        days: `${days}天`,
        hours: `${hours}时`
      };
      return total_time;
    }
  }
};
</script>

<style scoped lang="scss" type="text/scss">
.orderList {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  padding-top: 110px;
  box-sizing: border-box;
  background: url("~@/assets/images/user/walletBg.png") no-repeat 0 0;
  background-size: 100% 559px;
  background-color: #fff;;
  .carBlock {
    padding: 30px 50px 220px;
    color: #fff;
    .carInfo {
      display: flex;
      justify-content: space-between;
      height:110px;
      .left {
        display: flex;
        .carImg {
          width: 185px;
          height: 104px;
        }
        .carinfo {
          display: flex;
          flex-direction: column;
          margin-left: 20px;
          .carname {
            margin-bottom: 10px;
            font-size: 34px;
            font-weight: bold;
            text-overflow:ellipsis;
            white-space: nowrap;
            width: 300px;
            overflow: hidden;
          }
        }
      }
      .right {
        display: flex;
        flex-direction: column;
        text-align: right;
        .amount {
          margin-top: 10px;
          font-size: 32px;
          font-weight: bold;
        }
      }
    }
  }
  .orderBlock {
    padding: 0 25px;
    box-sizing: border-box;
    background: #fff;
    height: auto;
    .con {
      position: relative;
      bottom: 180px;
      width: 700px;
      min-height: 500px;
      height: 100%;
      background: #fff;
      box-shadow: 0 0 6px #ccc;
      -webkit-box-shadow:0 0 6px #ccc ;
      border-radius: 20px;
      background: #fff;
      .item {
        padding: 10px 26px;
        box-sizing: border-box;
        &:last-child {
          .bottom {
            border: none;
          }
        }
        .carsInfo {
          display: flex;
          justify-content: space-between;
          line-height: 40px;
          padding: 15px 0 5px;
          .orderNum {
            color: #9F9F9F;
          }
          .carStatus {
            color: #027FFF;
          }
        }
        .top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 0 10px;
          box-sizing: border-box;
          color: #9F9F9F;
          .date {
            position: relative;
            display: flex;
            justify-content: center;
            padding: 10px 0;
            box-sizing: border-box;
            width: 182px;
            border-radius: 25px;
            box-shadow: 0 0 0 1px #9F9F9F;/*no*/
            -webkit-box-shadow:0 0 0 1px #9F9F9F;/*no*/
            &:before {
              content: "";
              left: -32px;
              position: absolute;
              top: 25px;
              width: 30px;
              height: 2px;
              background-color: #b7b7b7;
            }
            &:after {
              content: "";
              right: -32px;
              position: absolute;
              top: 25px;
              width: 30px;
              height: 2px;
              background-color: #b7b7b7;
            }
          }
        }
        .bottom {
          display: flex;
          justify-content: space-between;
          padding-bottom: 20px;
          box-sizing: border-box;
          color: #000;
          border-bottom: 1px solid #b7b7b7;/*no*/
          .amount {
            color: #027fff;
            font-weight: bold;
            font-size: 32px;
          }
          .NoAmount {
            font-size: 23px;
            font-weight: bold;
            color: #000;
          }
        }
      }
      .nodata{
        display: flex;
        flex-direction: column;
        padding-top: 150px;
        box-sizing: border-box;
        text-align: center;
        color: #9f9f9f;
        img{
          margin: 0 auto;
          width: 316px;
          height: 200px;
        }
        span{
          margin-top: 10px;
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/orderList.vue